export const locale = {
    lang: 'en',
    data: {
        NAV: {
            DASHBOARD: 'Dashboard',
            CLIENTS: 'Clients',
            CONTRACTS: {
                CONTRACTS: 'Contracts',
                LIST: 'List',
                NEW: 'Create',
            },
            ADVISORS: {
                ADVISORS: 'Advisors',
                LIST: 'List',
                TREE: 'Tree',
                MANUFACTORY: 'Manufactory',
                COMMISSION: 'Commission',
                NEW: 'Create',
            },
            REPORTS: {
                TITLE: 'Reports',
                ADVISORS: 'Advisors\'',
                HQ: 'HQ',
            },
            APPLICANTS: {
                LIST: 'Applicants',
            }
        }
    }
};
